/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { useEffect } from 'react';

import { InfoCardManager } from '../../core/infocard';

/**
 * The `useInfoCard` is a React hook to subscribe to InfoCard dismissal events.
 * Registers the provided callback for InfoCard dismissals and clears the context on cleanup.
 * @param context - The context string to clear when the component unmounts.
 * @param onDismissed - Callback function invoked when the InfoCard is dismissed.
 */
const useInfoCard = (context: string, onDismissed: () => void) => {
    useEffect(() => {
        const infoCardManager = InfoCardManager.getInstance();
        infoCardManager.onInfoCardDismissed(onDismissed);

        return () => {
            infoCardManager.onInfoCardDismissed(() => {});
            infoCardManager.clearContext(context);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useInfoCard;
